module.exports = __webpack_public_path__ + "static/media/card-profile4.83bb1a63.jpg";